import React from 'react';
import { Components } from './styled';
import { parseDateToStringWithFormat } from '../../../../utils/dateFormat';
import { formats, localizer } from './constants';
import { customSlotPropGetter } from './utils';
import CalendarDefaultEvent from '../../events/CalendarDefaultEvent';
import CalendarMonthEvent from '../../events/CalendarMonthEvent';
import { Event as ReactBigCalendarEvent, SlotInfo } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { CalendarEvent } from '../../../../api/types/event';

const CalendarView = ({
  selectedDate,
  events,
  onShowMore,
  onSelectEvent,
  onSelectSlot,
}: {
  selectedDate: Date;
  events: CalendarEvent[];
  onShowMore: (date: Date) => void;
  onSelectEvent?: (event: CalendarEvent) => void;
  onSelectSlot: (date: Date) => void;
}) => {
  const today = new Date();

  const _onShowMore = (events: ReactBigCalendarEvent[], date: Date) => {
    onShowMore?.(date);
  };

  const _onSelectSlot = (slotInfo: SlotInfo) => {
    onSelectSlot?.(slotInfo?.start);
  };

  return (
    <Components.Container>
      <Components.Calendar
        date={selectedDate}
        onNavigate={() => {}}
        localizer={localizer}
        events={events}
        formats={formats}
        view={'month'}
        onView={() => {}}
        selectable
        onSelectSlot={_onSelectSlot}
        isDayView={false}
        defaultView={'month'}
        scrollToTime={today}
        slotPropGetter={customSlotPropGetter}
        onShowMore={_onShowMore}
        onSelectEvent={(event: any) => onSelectEvent?.(event as CalendarEvent)}
        components={{
          event: CalendarDefaultEvent,
          month: {
            dateHeader: ({ date }) => (
              <Components.DateCellDay>{parseDateToStringWithFormat(date, 'd')}</Components.DateCellDay>
            ),
            header: ({ date }) => <span>{parseDateToStringWithFormat(date, 'EEE')}</span>,
            event: CalendarMonthEvent,
          },
        }}
        toolbar={false}
        showAllEvents={false}
        doShowMoreDrillDown
        dayLayoutAlgorithm='no-overlap'
      />
    </Components.Container>
  );
};

export default CalendarView;
